/**
 * The server environment from `/api/config` (04 §6.3 A2). The test hook is installed only outside production
 * (AC-NFR-05); offline, the last known value is used, and an unknown environment counts as production.
 */
const KEY = 'tarock.env';

/** Resolves the environment name (`production`, `staging`, `test`, `development`). */
export async function serverEnv(timeoutMs = 3000): Promise<string> {
  try {
    const ctl = new AbortController();
    const id = setTimeout(() => ctl.abort(), timeoutMs);
    const r = await fetch('/api/config', { signal: ctl.signal, credentials: 'same-origin' });
    clearTimeout(id);
    const env = ((await r.json()) as { env?: unknown }).env;
    if (typeof env === 'string') {
      try {
        localStorage.setItem(KEY, env);
      } catch {
        // not persisted; fine
      }
      return env;
    }
  } catch {
    // offline or no API (vite dev without wrangler)
  }
  try {
    return localStorage.getItem(KEY) ?? 'production';
  } catch {
    return 'production';
  }
}
